module.exports = __webpack_public_path__ + "img/Group-5119.451c8d57.svg";